"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGenplanShowHandler = void 0;
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _react = require("react");
const useGenplanShowHandler = onView => {
  const {
    ref,
    inView
  } = (0, _valuationUtilsComponent.useInView)({
    threshold: 0,
    triggerOnce: true
  });
  (0, _react.useEffect)(() => {
    if (inView && onView) {
      onView();
    }
  }, [inView, onView]);
  return ref;
};
exports.useGenplanShowHandler = useGenplanShowHandler;